import React from 'react';
import { Accordion, AccordionItem } from '@riac/design-system';

interface IFilterSection {
  isLoading: boolean;
  heading: string;
  children(): React.ReactNode;
}
// Header for Filter and handle loading status. Pass children as a function to only evaluate after loading is complete
export const FilterSection = ({ isLoading, heading, children }: IFilterSection) => (
  <div className='flex justify-stretch min-w-[230px] py-1 border-b-1 border-b-surface-darker flex-1'>
    <AccordionItem heading={heading} className='flex flex-1 justify-stretch' buttonClassName='py-2 w-full justify-between text-[16px] leading-6 tracking-wide font-default font-bold text-text'>
      {isLoading ? '...' : children()}
    </AccordionItem>
  </div>
);
